
import React from "react";
import { ExternalLink, Cookie } from "lucide-react";
import { openConsentSettings } from "@/lib/analytics/consent";

const Footer: React.FC = () => {
  return (
    <footer className="py-4 px-4 border-t mt-auto bg-gradient-to-r from-indigo-50 to-purple-50">
      <div className="container mx-auto flex justify-center items-center text-sm text-gray-500">
        <span>Powered by</span>
        <a
          href="https://www.n-micro.ca"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center ml-1 text-primary hover:underline"
        >
          N-Micro IT Solutions Inc.
          <ExternalLink className="h-3 w-3 ml-1" />
        </a>
      </div>
      <div className="container mx-auto flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-2 text-xs text-gray-500">
        <span>&copy; 2025 Grade Test Pro. All rights reserved.</span>
        <span aria-hidden="true">·</span>
        <button
          type="button"
          onClick={openConsentSettings}
          className="inline-flex items-center gap-1 text-primary hover:underline"
        >
          <Cookie className="h-3 w-3" />
          Cookie settings
        </button>
      </div>
    </footer>
  );
};

export default Footer;
